import React, { useState, useCallback } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion } from "framer-motion"; // 🚀 Import motion

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    country: "",
    username: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = useCallback((e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.password || !formData.country || !formData.username) {
      setMessage("All fields are required");
      return;
    }
    try {
      const response = await axios.post(`/auth/admin/register`, formData);
      setMessage(response.data.message);
      setFormData({ name: "", email: "", password: "", country: "", username: "" });
    } catch (error) {
      console.log(error);
      setMessage(error.response?.data?.message || "Error registering user");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <motion.div
        className="card p-4 shadow-lg border-0 rounded-4"
        style={{ width: "400px" }}
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <motion.div
          className="text-center mb-3"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <img src="https://timehouse.store/logo-red.svg" alt="Logo" width="150" />
        </motion.div>

        <motion.h3
          className="text-center fw-bold"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Create an Account
        </motion.h3>

        {message && (
          <motion.div
            className={`alert ${message.includes("Error") ? "alert-danger" : "alert-success"} text-center`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            {message}
          </motion.div>
        )}

        <form onSubmit={handleSubmit}>
          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <label className="form-label fw-semibold">Name</label>
            <input
              type="text"
              name="name"
              className="form-control rounded-3"
              placeholder="Enter the name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45 }}
          >
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              name="username"
              className="form-control rounded-3"
              placeholder="Enter the employee code"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <label className="form-label fw-semibold">Email Address</label>
            <input
              type="email"
              name="email"
              className="form-control rounded-3"
              placeholder="Enter the email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.55 }}
          >
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              name="password"
              className="form-control rounded-3"
              placeholder="Enter the password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </motion.div>

          <motion.div
            className="mb-3"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <label className="form-label fw-semibold">Country</label>
            <select
              name="country"
              className="form-control rounded-3"
              value={formData.country}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Select Country</option>
              <option value="India">India</option>
              <option value="UAE">UAE</option>
              <option value="Qatar">Qatar</option>
              <option value="Saudi">Saudi</option>
              <option value="Oman">Oman</option>
              <option value="Kuwait">Kuwait</option>
            </select>
          </motion.div>

          <motion.button
            type="submit"
            className="btn btn-danger w-100 fw-bold rounded-3"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ duration: 0.2 }}
          >
            Register
          </motion.button>

          <motion.div
            className="text-center mt-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.65 }}
          >
            <small className="text-muted">
              Already have an account? <a href="/login" className="text-danger fw-bold">Login</a>
            </small>
          </motion.div>
        </form>
      </motion.div>
    </div>
  );
};

export default Register;
